// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AngleDirectionController from "./angle_direction_controller"
application.register("angle-direction", AngleDirectionController)

import AutoMailingEditorController from "./auto_mailing_editor_controller"
application.register("auto-mailing-editor", AutoMailingEditorController)

import AutomaticFormSubmitController from "./automatic_form_submit_controller"
application.register("automatic-form-submit", AutomaticFormSubmitController)

import BatteryController from "./battery_controller"
application.register("battery", BatteryController)

import CalculatePowerController from "./calculate_power_controller"
application.register("calculate-power", CalculatePowerController)

import ChangeImageController from "./change_image_controller"
application.register("change-image", ChangeImageController)

import ChangeMaxBatteryCapacityController from "./change_max_battery_capacity_controller"
application.register("change-max-battery-capacity", ChangeMaxBatteryCapacityController)

import ChartRowController from "./chart_row_controller"
application.register("chart-row", ChartRowController)

import ChartSolverController from "./chart_solver_controller"
application.register("chart-solver", ChartSolverController)

import ClickToToggleController from "./click_to_toggle_controller"
application.register("click-to-toggle", ClickToToggleController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)

import ConfirmWithInputController from "./confirm_with_input_controller"
application.register("confirm-with-input", ConfirmWithInputController)

import ContactWidgetController from "./contact_widget_controller"
application.register("contact-widget", ContactWidgetController)

import ControlThresholdController from "./control_threshold_controller"
application.register("control-threshold", ControlThresholdController)

import CustomEventController from "./custom_event_controller"
application.register("custom-event", CustomEventController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DetailsAutoCloseController from "./details_auto_close_controller"
application.register("details-auto-close", DetailsAutoCloseController)

import DigitalTwinController from "./digital_twin_controller"
application.register("digital-twin", DigitalTwinController)

import DigitsOnlyController from "./digits_only_controller"
application.register("digits-only", DigitsOnlyController)

import DisableSubmitController from "./disable_submit_controller"
application.register("disable-submit", DisableSubmitController)

import ElectricityPlanController from "./electricity_plan_controller"
application.register("electricity-plan", ElectricityPlanController)

import EmptyStateController from "./empty_state_controller"
application.register("empty-state", EmptyStateController)

import EpexForecastGraphController from "./epex_forecast_graph_controller"
application.register("epex-forecast-graph", EpexForecastGraphController)

import EreAddressLookupController from "./ere_address_lookup_controller"
application.register("ere-address-lookup", EreAddressLookupController)

import FilterableListController from "./filterable_list_controller"
application.register("filterable-list", FilterableListController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FuseLimitController from "./fuse_limit_controller"
application.register("fuse-limit", FuseLimitController)

import GoogleAnalyticsController from "./google_analytics_controller"
application.register("google-analytics", GoogleAnalyticsController)

import GraphController from "./graph_controller"
application.register("graph", GraphController)

import HapticFeedbackController from "./haptic_feedback_controller"
application.register("haptic-feedback", HapticFeedbackController)

import HiddenSelectController from "./hidden_select_controller"
application.register("hidden-select", HiddenSelectController)

import HideSectionController from "./hide_section_controller"
application.register("hide-section", HideSectionController)

import I18nController from "./i18n_controller"
application.register("i18n", I18nController)

import LanguageToggleController from "./language_toggle_controller"
application.register("language-toggle", LanguageToggleController)

import LineNumbersController from "./line_numbers_controller"
application.register("line-numbers", LineNumbersController)

import MailingPreviewController from "./mailing_preview_controller"
application.register("mailing-preview", MailingPreviewController)

import MailingVariableParityController from "./mailing_variable_parity_controller"
application.register("mailing-variable-parity", MailingVariableParityController)

import MarkdownToolbarController from "./markdown_toolbar_controller"
application.register("markdown-toolbar", MarkdownToolbarController)

import MeterReadingGraphController from "./meter_reading_graph_controller"
application.register("meter-reading-graph", MeterReadingGraphController)

import NavigationProposalController from "./navigation_proposal_controller"
application.register("navigation-proposal", NavigationProposalController)

import PasswordFeedbackController from "./password_feedback_controller"
application.register("password-feedback", PasswordFeedbackController)

import PlanningGraphController from "./planning_graph_controller"
application.register("planning-graph", PlanningGraphController)

import PollVehicleController from "./poll_vehicle_controller"
application.register("poll-vehicle", PollVehicleController)

import PreSelectInputController from "./pre_select_input_controller"
application.register("pre-select-input", PreSelectInputController)

import PresentSsoController from "./present_sso_controller"
application.register("present-sso", PresentSsoController)

import PrimaryActionController from "./primary_action_controller"
application.register("primary-action", PrimaryActionController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import QuantileSliderController from "./quantile_slider_controller"
application.register("quantile-slider", QuantileSliderController)

import RelativeDatetimeController from "./relative_datetime_controller"
application.register("relative-datetime", RelativeDatetimeController)

import ReloadWhenForegroundedController from "./reload_when_foregrounded_controller"
application.register("reload-when-foregrounded", ReloadWhenForegroundedController)

import ScenarioGroupsController from "./scenario_groups_controller"
application.register("scenario-groups", ScenarioGroupsController)

import SectionToggleController from "./section_toggle_controller"
application.register("section-toggle", SectionToggleController)

import SegmentPromptController from "./segment_prompt_controller"
application.register("segment-prompt", SegmentPromptController)

import SentryController from "./sentry_controller"
application.register("sentry", SentryController)

import SliderInputController from "./slider_input_controller"
application.register("slider-input", SliderInputController)

import SocketReplaceController from "./socket_replace_controller"
application.register("socket-replace", SocketReplaceController)

import SolarArrayPreviewController from "./solar_array_preview_controller"
application.register("solar-array-preview", SolarArrayPreviewController)

import SubmitOnMetaEnterController from "./submit_on_meta_enter_controller"
application.register("submit-on-meta-enter", SubmitOnMetaEnterController)

import TreePreviewController from "./tree_preview_controller"
application.register("tree-preview", TreePreviewController)

import VehicleModelsPickerController from "./vehicle_models_picker_controller"
application.register("vehicle-models-picker", VehicleModelsPickerController)
